const isNonSortableKey = (key: string, nonSortableKeys: string[] = ['']) => {
    return nonSortableKeys.includes(key);
};


export const getSorter = (key: string, sortType: string) => {

    if(isNonSortableKey(key)) {
        return undefined;
    }

    switch (sortType) {
        case 'str':
            return (a: Record<string, string>, b: Record<string, string>) => a[key].localeCompare(b[key]);
        case 'date':
            return (a: Record<string, string>, b: Record<string, string>) => new Date(a[key]).getTime() - new Date(b[key]).getTime();
        default:
            return undefined;
    }
};